import { CSSObject } from "@mantine/core";
export const styles = () => ({
  root: {
    paddingTop: "100px",
    paddingBottom: "50px",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  } as CSSObject,
});
